import { Card, Row, Col } from "react-bootstrap";
import Currency from "../currency";
import CurrencyFormat from "../currencyFormat/currencyFormat";
import { useSelector } from "react-redux";
import { RoutesPaths } from "../../Router/constant";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";

const PlanSummary = ({ planPreview, isKimbocorp, values, pageType = false }) => {
  return (
    <Card className="plan-summary-card shadow-sm p-4 rounded-4">
      <Row>
        {pageType && planPreview?.status === "estimated" &&
          <Col md={12} className="info-row">
            <div className="copy-link-wrapper">
              <label className="form-label mb-2">Payment link</label>
              <div className="d-flex">
                <input
                  type="text"
                  className="form-control"
                  value={window?.location?.origin + RoutesPaths.PAY_BANKTRANSFER_PUBLIC.replace(":slug", planPreview.plan?.slug)}
                  readOnly
                  style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                />
                <CopyToClipboard
                  text={window?.location?.origin + RoutesPaths.PAY_BANKTRANSFER_PUBLIC.replace(":slug", planPreview.plan?.slug)}
                >
                  <button
                    onClick={() => toast.success("Copied!")}
                    type="button"
                    className="customFilterButton"
                    style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                  >
                    Copy link
                  </button>
                </CopyToClipboard>
              </div>
            </div>
          </Col>
        }
        <Col md={6} className="info-row">
          <p className="label">Company name:</p>
        </Col>
        <Col md={6} className="info-row">
          <p className="value">{values?.company?.companyName}</p>
        </Col>
        {/* {!pageType &&
          <>
            <Col md={6} className="info-row">
              <p className="label">Plan:</p>
            </Col>
            <Col md={6} className="info-row">
              <p className="value">{values?.plan?.name}</p>
            </Col>
          </>
        }
        <Col md={6} className="info-row">
          <p className="label">Plan Highlights:</p>
        </Col>
        <Col md={6} className="info-row">
          <p className="value" dangerouslySetInnerHTML={{ __html: values?.plan?.targetAudience }}></p>
        </Col> */}
      </Row>
      {/* Price breakdown section */}
      <div className="price-box p-3 mt-3 rounded-3">
        <Row className="mb-1">
          <Col>Price</Col>
          <Col className="text-end">
            <Currency
              currency={values?.currency?.value || ""}
            />
            <CurrencyFormat
              currency={values?.currency?.value}
              value={parseFloat(pageType ? planPreview?.planAmount : planPreview?.amount)}
              decimal={2}
            />
          </Col>
        </Row>
        <Row className="mb-1">
          <Col>
            {isKimbocorp ? "Commission" : "Platform fee"}({isKimbocorp ? planPreview?.advisorShare : planPreview?.kimbocorpShare}%) <span className="infoicon"><img
              src="assets/img/info-icon.svg"
              alt=""
              className="m-0 pb-1 cursorPointer"
            /></span>
          </Col>
          <Col className="text-end">{isKimbocorp ? <>
            <Currency
              currency={values?.currency?.value || ""}
            />
            <CurrencyFormat
              currency={values?.currency?.value}
              value={parseFloat(planPreview?.advisorShareAmount)}
              decimal={2}
            />
          </> :
            <>
              <Currency
                currency={values?.currency?.value || ""}
              />
              <CurrencyFormat
                currency={values?.currency?.value}
                value={parseFloat(planPreview?.kimbocorpShareAmount)}
                decimal={2}
              />
            </>}</Col>
        </Row>
        <Row className="mb-1">
          <Col>Net Earnings</Col>
          <Col className="text-end">
            <Currency
              currency={values?.currency?.value || ""}
            />
            <CurrencyFormat
              currency={values?.currency?.value}
              value={parseFloat(planPreview?.advisorShareAmount)}
              decimal={2}
            />
          </Col>
        </Row>
        {/* <Row className="mb-1">
          <Col>Platform Gets</Col>
          <Col className="text-end">
            <Currency
              currency={values?.currency?.value || ""}
            />
            <CurrencyFormat
              currency={values?.currency?.value}
              value={parseFloat(planPreview?.kimbocorpShareAmount)}
              decimal={2}
            />
          </Col>
        </Row> */}
        <hr />
        <Row>
          <Col className="fw-normal totaltxt">Total</Col>
          <Col className="text-end compSideBarHeader">
            <Currency
              currency={values?.currency?.value || ""}
            />
            <CurrencyFormat
              currency={values?.currency?.value}
              value={parseFloat(pageType ? planPreview?.planAmount : planPreview?.amount)}
              decimal={2}
            />
          </Col>
        </Row>
      </div>
    </Card>
  );
};

export default PlanSummary;
